document.addEventListener("alpine:init", () => {
  Alpine.data("etfListing", () => ({
    /**
     * Data
     */
    ...JSON.parse(
      document.querySelector("[data-etf-listing]").dataset.etfListing
    ),

    /**
     * The localized percentage for a given number.
     *
     * @param {Number} number
     * @return string
     */
    formatPercent(number) {
      const formatter = new Intl.NumberFormat(document.documentElement.lang, {
        style: "percent",
        minimumFractionDigits: 0,
        maximumFractionDigits: 4,
      });

      return formatter.format(number / 100);
    },

    /**
     * Filters
     */
    get activeFilters() {
      return Object.entries(this.filterGroups)
        .map(([_, value]) => value.firstLevel.filter((option) => option.active))
        .flat();
    },
    get activeFiltersByGroup() {
      return Object.fromEntries(
        Object.entries(this.filterGroups).map(([key, value]) => [
          key,
          value.firstLevel.filter((option) => option.active),
        ])
      );
    },
    get activeFilterValuesByGroup() {
      return Object.fromEntries(
        Object.entries(this.filterGroups).map(([key, value]) => [
          key,
          value.firstLevel
            .filter((option) => option.active)
            .map((option) => option.value),
        ])
      );
    },
    get activeSecondFilters() {
      return Object.entries(this.filterGroups)
        .map(([_, value]) =>
          value.secondLevel.filter((option) => option.active)
        )
        .flat();
    },
    get activeSecondFiltersByGroup() {
      return this.filterGroups["categories"].secondLevel.filter(
        (option) => option.active
      );
    },
    get activeSecondFilterValuesByGroup() {
      return Object.fromEntries(
        Object.entries(this.filterGroups).map(([key, value]) => [
          key,
          value.secondLevel
            ? value.secondLevel
                .filter((option) => option.active)
                .map((option) => option.value)
            : null,
        ])
      );
    },
    get activeThirdFilters() {
      return Object.entries(this.filterGroups)
        .map(([_, value]) => value.thirdLevel.filter((option) => option.active))
        .flat();
    },
    get activeThirdFiltersByGroup() {
      return this.filterGroups["categories"].thirdLevel.filter(
        (option) => option.active
      );
    },
    get activeThirdFilterValuesByGroup() {
      return Object.fromEntries(
        Object.entries(this.filterGroups).map(([key, value]) => [
          key,
          value.thirdLevel
            ? value.thirdLevel
                .filter((option) => option.active)
                .map((option) => option.value)
            : null,
        ])
      );
    },
    setFilterActive(
      filterGroup,
      value,
      isActive = true,
      filters = "firstLevel"
    ) {
      this.resetPaging();

      if (filterGroup == "category") {
        const secondLevelFilters = this.filterGroups[filterGroup].secondLevel;
        const thirdLevelFilters = this.filterGroups[filterGroup].thirdLevel;
        const secondTotalFilters = secondLevelFilters.filter((filter) => {
          return filter.active;
        }).length;
        const thirdTotalFilters = thirdLevelFilters.filter((filter) => {
          return filter.active;
        }).length;

        if (filters === "firstLevel") {
          secondTotalFilters > 0
            ? (secondLevelFilters.filter(
                (filter) => filter.active ?? false
              )[0].active = isActive)
            : null;
          thirdTotalFilters > 0
            ? (thirdLevelFilters.filter(
                (filter) => filter.active ?? false
              )[0].active = isActive)
            : null;
        }

        if (filters === "secondLevel" && thirdTotalFilters > 0) {
          thirdLevelFilters.filter(
            (filter) => filter.active ?? false
          )[0].active = isActive;
        }
      }

      this.filterGroups[filterGroup][filters].find(
        (option) => option.value === value
      ).active = isActive;

      return true;
    },
    //Allows only one filter per category to be selected
    setSoloFilter(filter, currentCategory, level = "firstLevel") {
      this.resetPaging();
      let filterGroups = Object.entries(this.filterGroups).map(
        ([key, _]) => key
      );
      if (level === "firstLevel") {
        let filters = Object.fromEntries(
          Object.entries(this.filterGroups).map(([key, value]) => [
            key,
            value.firstLevel
              .filter((option) => option.active)
              .map((option) => option.value),
          ])
        );
        let secondFilters = Object.fromEntries(
          Object.entries(this.filterGroups).map(([key, value]) => [
            key,
            key === "categories"
              ? value.secondLevel
                  .filter((option) => option.active)
                  .map((option) => option.value)
              : null,
          ])
        );
        let thirdFilters = Object.fromEntries(
          Object.entries(this.filterGroups).map(([key, value]) => [
            key,
            key === "categories"
              ? value.thirdLevel
                  .filter((option) => option.active)
                  .map((option) => option.value)
              : null,
          ])
        );
        filterGroups.map((filterGroup) => {
          if (
            currentCategory.toLowerCase().includes(filterGroup.slice(0, 3)) &&
            filters[filterGroup].length > 0
          ) {
            filterGroup === "categories" && thirdFilters[filterGroup].length > 0
              ? this.setFilterActive(
                  filterGroup,
                  thirdFilters[filterGroup][0],
                  false,
                  "thirdLevel"
                )
              : null;
            filterGroup === "categories" &&
            secondFilters[filterGroup].length > 0
              ? this.setFilterActive(
                  filterGroup,
                  secondFilters[filterGroup][0],
                  false,
                  "secondLevel"
                )
              : null;
            filters[filterGroup][0] !== filter
              ? this.setFilterActive(
                  filterGroup,
                  filters[filterGroup][0],
                  false
                )
              : null;
          }
        });
      } else if (level === "secondLevel") {
        let secondFilters = Object.fromEntries(
          Object.entries(this.filterGroups).map(([key, value]) => [
            key,
            key === "categories"
              ? value.secondLevel
                  .filter((option) => option.active)
                  .map((option) => option.value)
              : null,
          ])
        );
        let thirdFilters = Object.fromEntries(
          Object.entries(this.filterGroups).map(([key, value]) => [
            key,
            key === "categories"
              ? value.thirdLevel
                  .filter((option) => option.active)
                  .map((option) => option.value)
              : null,
          ])
        );
        filterGroups.map((filterGroup) => {
          if (
            currentCategory.toLowerCase().includes(filterGroup.slice(0, 3)) &&
            secondFilters[filterGroup].length > 0
          ) {
            filterGroup === "categories" && thirdFilters[filterGroup].length > 0
              ? this.setFilterActive(
                  filterGroup,
                  thirdFilters[filterGroup][0],
                  false,
                  "thirdLevel"
                )
              : null;

            secondFilters[filterGroup][0] !== filter
              ? this.setFilterActive(
                  filterGroup,
                  secondFilters[filterGroup][0],
                  false,
                  "secondLevel"
                )
              : null;
          }
        });
      } else if (level === "thirdLevel") {
        let filters = Object.fromEntries(
          Object.entries(this.filterGroups).map(([key, value]) => [
            key,
            key === "categories"
              ? value.thirdLevel
                  .filter((option) => option.active)
                  .map((option) => option.value)
              : null,
          ])
        );
        filterGroups.map((filterGroup) => {
          if (
            currentCategory.toLowerCase().includes(filterGroup.slice(0, 3)) &&
            filters[filterGroup].length > 0
          ) {
            filters[filterGroup][0] !== filter
              ? this.setFilterActive(
                  filterGroup,
                  filters[filterGroup][0],
                  false,
                  "thirdLevel"
                )
              : null;
          }
        });
      }
    },
    removeFilters(filters) {
      this.resetPaging();
      filters.map((filter) => {
        this.filterGroups[filter].firstLevel.map((option) => {
          if (option.active === option.value) {
            option.active = false;
          }
        });
        if (filter === "categories") {
          this.filterGroups[filter].secondLevel.map((option) => {
            if (option.active === option.value) {
              option.active = false;
            }
          });

          this.filterGroups[filter].thirdLevel.map((option) => {
            if (option.active === option.value) {
              option.active = false;
            }
          });
        }
      });

      return true;
    },
    /*
    filteredEtfs
    checks if etfs match any selected filters if selected filters are of the same filter bucket
    checks if etfs match all selected filters if selected filters are of different filter buckets
    */
    filteredEtfs(
      etfs,
      filterValuesByGroup,
      secondFilterValuesByGroup = {},
      thirdLevelFilterValuesByGroup = {},
      category = null
    ) {
      const activeFilterGroups = (activeFiltersByGroup) => {
        return [
          ...new Set(
            Object.entries(activeFiltersByGroup)
              .filter(([_, value]) => value.length > 0)
              .map(([key, _]) => key)
          ),
        ];
      };

      return Object.fromEntries(
        Object.entries(etfs)
          .map(([group, etfs]) => {
            if (category === null) {
              return [group, etfs];
            }

            return [
              group,
              etfs.filter((etf) => {
                return etf.categories
                  .map(Object.values)
                  .flat()
                  .includes(category);
              }),
            ];
          })
          .map(([group, etfs]) => [
            group,
            etfs.filter((etf) => {
              return activeFilterGroups(filterValuesByGroup).every((group) => {
                if (!(group in etf)) {
                  return false;
                }
                return (
                  etf[group]
                    .map((item) => Object.values(item))
                    .flat()
                    .filter((value) =>
                      thirdLevelFilterValuesByGroup[group] &&
                      thirdLevelFilterValuesByGroup[group].length > 0
                        ? thirdLevelFilterValuesByGroup[group].includes(value)
                        : secondFilterValuesByGroup[group] &&
                          secondFilterValuesByGroup[group].length > 0
                        ? secondFilterValuesByGroup[group].includes(value)
                        : filterValuesByGroup[group].includes(value)
                    ).length > 0
                );
              });
            }),
          ])
          .filter(([_, etfs]) => etfs.length > 0)
      );
    },
    visibleCategories(etfs) {
      return [
        ...new Set(
          Object.values(etfs)
            .flat()
            .map((etf) => etf.categories.map((category) => category.title))
            .flat()
        ),
      ];
    },

    /**
     * Pagination
     */
    resetPaging() {
      this.currentPage = {
        UNFILTERED: 1,
      };

      this.totalPages = {
        UNFILTERED: 1,
      };
    },
    currentPage: {
      UNFILTERED: 1,
    },
    totalPages: {
      UNFILTERED: 1,
    },
    perPage: 20,

    paginatedEtfs(etfs, category = "UNFILTERED") {
      if (category !== "UNFILTERED") {
        if (!(category in this.currentPage)) {
          this.currentPage[category] = 1;
        }

        if (!(category in this.totalPages)) {
          this.totalPages[category] = 1;
        }
      }

      const perPage =
        category === "UNFILTERED" ? this.perPage : this.perPageFiltered;
      this.totalPages[category] = Math.ceil(Object.keys(etfs).length / perPage);

      const sumGroupAum = (items) =>
        items
          .map((item) => {
            if (typeof item.aum !== "string") {
              return 0;
            }

            return parseInt(item.aum.replace(/,/g, ""));
          })
          .reduce((a, b) => a + b, 0);

      const sortedEtfs = Object.fromEntries(
        Object.entries(etfs).sort(
          ([groupA, groupAItems], [groupB, groupBItems]) => {
            // Sort results by highest cumulative AUM.
            const sumA = sumGroupAum(groupAItems);
            const sumB = sumGroupAum(groupBItems);

            if (sumA < sumB) {
              return 1;
            }

            if (sumA > sumB) {
              return -1;
            }

            return 0;
          }
        )
      );

      return Object.fromEntries(
        Object.entries(sortedEtfs)
          .map(([key, items]) => {
            if (!items.some((item) => !!item.manualSortOrder)) {
              return [key, items];
            }

            return [
              key,
              items.sort((a, b) => a.manualSortOrder - b.manualSortOrder),
            ];
          })
          .filter(([key, _]) =>
            Object.keys(sortedEtfs)
              .splice(0, this.currentPage[category] * perPage)
              .includes(key)
          )
      );
    },
    doPaginate(category) {
      this.currentPage[category] = this.currentPage[category] + 10;
    },
    pagesRemaining(etfs, category) {
      if (category !== "UNFILTERED") {
        if (!(category in this.currentPage)) {
          this.currentPage[category] = 1;
        }

        if (!(category in this.totalPages)) {
          this.totalPages[category] = 1;
        }
      }
      const perPage =
        category === "UNFILTERED" ? this.perPage : this.perPageFiltered;

      this.totalPages[category] = Math.ceil(Object.keys(etfs).length - perPage);

      return "(" + this.totalPages[category] + ")";
    },
  }));
});
